import ActionTypePlan from "../ActionTypePlan";

export default class GuardarPlan extends ActionTypePlan {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = true;
        // nuevoEstado.flag.sensorDeAccionGuardar = !(estado.flag.sensorDeAccionGuardar);
        // nuevoEstado.flag.sensorDeAccionGuardar = this.payload;
        return nuevoEstado;
    }
}
